module.exports = __webpack_public_path__ + "img/fxpd.469c9839.png";